<template>
  <div>
    <v-row>
      <v-col cols="12">
        <span> Is Employee EIS Contribute? </span>
        <v-radio-group
          v-model="isEmployeeEisContribute"
          row
        >
          <v-radio
            label="No"
            :value="0"
          />
          <v-radio
            label="Yes"
            :value="1"
          /> 
        </v-radio-group>
      </v-col>
      <v-col cols="12">
        <span> Is Employer EIS Contribute? </span>
        <v-radio-group
          v-model="isEmployerEisContribute"
          row
        >
          <v-radio
            label="No"
            :value="0"
          />
          <v-radio
            label="Yes"
            :value="1"
          /> 
        </v-radio-group>
      </v-col>
      <v-col cols="12">
        <v-menu
          v-model="startDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
          max-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startDateDisplay"
              v-validate="'required'"
              :error-messages="errors.collect('startDateDisplay')"
              data-vv-name="startDateDisplay"
              data-vv-as="start date"
              label="Start date"
              readonly
              outlined
              class="label-position"
              v-on="on"
            >
              <template v-slot:prepend-inner>
                <v-icon>
                  mdi-calendar
                </v-icon>
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="startDate"
            type="month"
            :min="$moment().subtract(1, 'months').format('YYYY-MM')"
            no-title
            @input="startDateMenu = false"
          />
        </v-menu>
      </v-col>
    </v-row>

    <v-card-actions>
      <v-spacer />
      <v-btn
        :disabled="progressing"
        class="px-10"
        text
        @click="closeDialog"
      >
        Close
      </v-btn>
      <v-btn
        :loading="progressing"
        color="hrissecondary"    
        class="white--text px-10"       
        @click="submitForm"
      >
        submit
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      companyEmployeeUid: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        startDateMenu: false,
        startDate: null,
        isEmployeeEisContribute: 1,
        isEmployerEisContribute: 1,
        progressing: false,
      }
    },
    computed: {
      startDateDisplay () {
        return this.startDate ? this.$moment(this.startDate + '-01', 'YYYY-MM-DD').format('MMM YYYY') : ''
      },
      
    },
    methods: {
      submitForm () {
        this.$validator.resume()
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)

            this.$api.companyEmployeeEisContributions().create(this.companyEmployeeUid, this.prepareFormData())
              .then(res => {
                this.$emit('created')
                this.$snack({ message: res.data.status })
                
                this.$validator.pause()
                this.setProgressing(false)
              })
              .catch((err) => {
                if (err.response.status === 422) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }            
            
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          start_date: this.startDate + '-01',
          is_employee_contributed: this.isEmployeeEisContribute,
          is_employer_contributed: this.isEmployerEisContribute,
        }
      },
      closeDialog () {
        this.$emit('close-dialog')
      },
      setProgressing (status) {
        this.progressing = status
      },
      clearData () {
        this.startDateMenu = false
        this.startDate = null
        this.isEmployeeEisContribute = 1
        this.isEmployerEisContribute = 1
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:4px
}
</style>
